import { Link } from "react-router-dom";
import { PageMeta } from "@/components/PageMeta";
import { ContentPageShell } from "@/components/ContentPageShell";
import { POSTS } from "@/content/blog";

export default function Blog() {
  const sorted = [...POSTS].sort((a, b) => b.date.localeCompare(a.date));
  return (
    <>
      <PageMeta
        title="Blog — Tipomatic"
        description="Návody, tipy a statistiky ke tipování mistrovství světa a Evropy ve fotbale. Jak vyhrát vlastní tipovací ligu."
        path="/blog"
      />
      <ContentPageShell>
        <h1 className="text-3xl md:text-4xl font-bold mb-2">Blog</h1>
        <p className="text-pitch-cream/60 mb-10">
          Návody, statistiky a strategie pro tipování velkých fotbalových turnajů.
        </p>
        <div className="space-y-4">
          {sorted.map((post) => (
            <Link
              key={post.slug}
              to={`/blog/${post.slug}`}
              className="block border border-pitch rounded-2xl p-6 bg-white/[0.02] hover:bg-white/[0.05] transition"
            >
              <div className="text-xs uppercase tracking-wider text-primary mb-2">
                {post.lang === "cs" ? "Česky" : "English"} · {post.date} · {post.readingMinutes} min
              </div>
              <h2 className="text-xl font-bold text-pitch-cream mb-2">{post.title}</h2>
              <p className="text-sm text-pitch-cream/70 leading-relaxed">{post.description}</p>
            </Link>
          ))}
        </div>
      </ContentPageShell>
    </>
  );
}
